import api from '../api'
import router from '../router';
const state = {
    videos: null,
    loading: false,
    isAnonymous: localStorage.getItem('login') ? (JSON.parse(localStorage.getItem('login'))).isAnonymous : true,
    ageLimit: [],
    leaderboard: localStorage.getItem('leaderboard') ? JSON.parse(localStorage.getItem('leaderboard')) : [],
    successLogin: false,
};

const mutations = {
    setLoading(state, loading) {
        state.loading = loading;
    },
    setLoginData(state, loginData) {
        state.successLogin = true;
        localStorage.setItem('login', loginData);
    },
    setAgeLimit(state, ageLimit) {
        state.ageLimit = ageLimit;
    },
    setLeaderboardData(state, leaderboard) {
        state.leaderboard = leaderboard;
    },
    setVideos(state, videos) {
        state.videos = videos;
    },
};

const getters = {
    getLeaderBoard(state) {
        let rank = 0;
        return state.leaderboard?.leaderboard?.map(leaderboard => {
            rank = leaderboard?.rank ?? rank + 1;
            return {
                rank: leaderboard?.rank ?? rank,
                name: leaderboard?.name ?? (localStorage.getItem("name") ? localStorage.getItem("name") : "-"),
                company: leaderboard?.company ?? "",
                mobile: leaderboard?.mobile ?? "",
                accuracy: leaderboard?.accuracy ?? 0,
                email: leaderboard?.email ?? ""
            }
        })
    }
};

const actions = {
    async loginProcess({ commit }, credentials) {
        commit('setLoading', true);
        try {
            const data = await api.login(credentials);
            if (data) {
                commit('setLoginData', JSON.stringify({ isAnonymous: false, ...data }))
            }
        }
        catch (e) {
            commit('setLoading', false);
        }
        finally {
            commit('setLoading', false);
        };
    },
    async uploadDetailsAndGetLeaderBoard({ commit, dispatch }, userDetails) {
        commit('setLoading', true);
        try {
            const data = await api.getLeaderBoard(userDetails);
            if (data) {
                localStorage.setItem('leaderboard', JSON.stringify(data));
                commit('setLeaderboardData', data)
            }
        }
        catch (e) {
            try {
                if (e?.status == 401) {
                    await dispatch("getRefreshToken");
                    const data = await api.getLeaderBoard(userDetails);
                    if (data) {
                        localStorage.setItem('leaderboard', JSON.stringify(data));
                        commit('setLeaderboardData', data)
                    }
                }
            } catch {
                Promise.reject(e);
            }
        }
        finally {
            commit('setLoading', false);
        };
    },
    async getRefreshToken({ commit }) {
        try {
            let data = await api.refreshToken();
            if (data) {
                commit('setLoginData', JSON.stringify({ isAnonymous: false, ...data }))
            }
        }
        catch (e) {
            localStorage.removeItem('login');
            router.push({ name: 'sign-in' })
        }
    },
    async loadVideos({ commit, dispatch }, videosId) {
        commit('setLoading', true);
        try {
            const videos = await api.getAllIdsVideos(videosId);
            commit('setVideos', videos);
            commit('setLoading', false);
            return videos;
        } catch (e) {
            try {
                await retry(e);
                const videos = await api.getAllIdsVideos(videosId);
                commit('setVideos', videos);
                commit('setLoading', false);
                return videos;
            } catch {
                Promise.reject(e);
            }
            commit('setLoading', false);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
}
